import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { Whale } from 'store/reporting/benchmark/types'

type Props = {
  targetWhale: Whale
  whales: Whale[]
  value: string
  onChange: (dn: string) => void
}

export function WhalesCompanySelect({ targetWhale, whales, value, onChange }: Props) {
  const otherWhales = whales.filter(w => w.dn !== targetWhale.dn)

  return (
    <Box minWidth={140} maxWidth={500}>
      <FormControl fullWidth size="small">
        <InputLabel>Company</InputLabel>
        <Select value={value} label="Company" onChange={e => onChange(e.target.value)}>
          {/* Target first */}
          <MenuItem value={targetWhale.dn} dense>
            * {targetWhale.dn} (Target)
          </MenuItem>

          {/* Rest */}
          {otherWhales.map(whale => (
            <MenuItem key={whale.dn} value={whale.dn} dense>
              {whale.dn ? <>{whale.dn}</> : <>No dn. Alias: {whale.an?.[0] || 'unknown'}</>}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
